<template>
  <q-btn
    class="q-mb-md"
    flat="flat"
    dense="dense"
    color="primary"
    icon="chevron_left"
    label="Back"
    @click="$router.back()"
  />
</template>
<script>
export default {
  name: 'BackButton',
};
</script>
